import { RecipeFeedback } from '@/types/recipe';
import { formatDistanceToNow } from 'date-fns';

interface RecipeFeedbackListProps {
  feedbacks: RecipeFeedback[];
}

const RecipeFeedbackList = ({ feedbacks }: RecipeFeedbackListProps) => {
  if (feedbacks.length === 0) {
    return (
      <div className="py-4">
        <p className="text-muted-foreground">No feedbacks yet. Be the first to leave a review!</p>
      </div>
    );
  }

  const formatDate = (dateString: string) => {
    try {
      return formatDistanceToNow(new Date(dateString), { addSuffix: true });
    } catch (e) {
      return "Unknown date";
    }
  };

  const renderStars = (rating: number | null) => {
    if (rating === null) return null;
    
    return (
      <div className="flex">
        {[1, 2, 3, 4, 5].map((star) => (
          <span key={star} className={`text-lg ${star <= rating ? 'text-yellow-400' : 'text-gray-300'}`}>
            {star <= rating ? '★' : '☆'}
          </span>
        ))}
      </div>
    );
  };

  return (
    <div className="space-y-6">
      {feedbacks.map((feedback) => (
        <div key={feedback.id} className="border-b pb-4 last:border-b-0">
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <span className="font-semibold">{feedback.firstName}</span>
              <span className="text-xs text-muted-foreground">
                {formatDate(feedback.createdAt)}
              </span>
            </div>
            {renderStars(feedback.rating)}
          </div>
          
          {feedback.comment && (
            <p className="text-sm mt-1">{feedback.comment}</p>
          )}
        </div>
      ))}
    </div>
  );
};

export default RecipeFeedbackList;
